<template>
    <v-container :class="{'pa-0': $vuetify.breakpoint.smAndDown, 'px-5 py-5': $vuetify.breakpoint.mdAndUp}">
        <div style="height: 35px;"/>
            <v-layout row wrap>
                <h2 style="font-size: 20px;  color: #9D4593;">Hola ¿Cuál es tu nombre?</h2> 
            </v-layout>
            <v-layout row wrap>
                <v-flex xs12 sm6 md5 style="margin: auto;">
                    <v-text-field label
                        class="pointer"
                        v-model="datos.personales.nombre"
                        color="#9D4593"
                        placeholder="Nombre"
                        ></v-text-field>
                </v-flex>
                <v-flex md1/>
                <v-flex xs12 sm6 md5 style="margin: auto;">
                    <v-text-field label
                        class="pointer"
                        v-model="datos.personales.apellido"
                        placeholder="Apellidos"
                        color="#9D4593"
                        ></v-text-field>
                    
                </v-flex>
                <div></div>
            </v-layout>
            <v-layout row wrap>
                <v-flex xs12 sm6 md1 style="margin: auto;">
                    <v-select
                        v-model="codigoDefault"
                        :items="codigos"
                        :rules="rules.nameRules"
                        append-icon="fas fa-caret-down"
                        label="Código País"
                        @change="changePhoneLength">
                        <img :src='require("../../../../assets/static/img/telefono.png")'  alt="icono de numero telefonico" style="width: 25px;height:25px;" slot="prepend">
                    </v-select>
                </v-flex>
                <v-flex xs12 sm6 md5 style="margin: auto;">
                    <v-text-field
                        v-model="datos.personales.telefono"
                        label="Teléfono"
                        color="#1f97b9"
                        :counter="phoneLength"
                        :maxlength="phoneLength"
                        :rules="rules.phoneRules"
                        required>
                    </v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4 style="margin: auto;">
                    <v-text-field 
                        slot="activator"
                        v-model="datos.personales.email"
                        label="Ingrese su Correo"
                        color="#1f97b9"
                        :rules="rules.emailRules"
                        required> 
                        <img :src='require("../../../../assets/static/img/email.png")'  alt="icono del email" style="width: 25px;height:25px;" slot="prepend">
                    </v-text-field>
                </v-flex>
                
            </v-layout>
            <v-layout md8></v-layout>
            <v-layout row wrap md4>
                <v-btn :disabled="datos.personales.nombre === '' || datos.personales.apellido === ''" @click="validate(true)" style="background-color: #9D4593; color: #FFFFFF;">Continuemos</v-btn>
            </v-layout>
            
    </v-container>
</template>

<script>

import { EventBus } from '../../../../events.js'
export default {
    name: 'nombre',
    data () {
        return {
            datos: {
                personales: {
                        nombre: '',
						telefono: '',
						email: '',
                        apellido: '',
                        nombrePila: ''
					},
                date: '',
                time: '',
                direccion_origen:{
                    direccion: "",
                    marker: {},
                    direccion_obj: {},
                    estacionamiento: ''
                },
                direccion_destino:{
                    direccion: "",
                    marker: {},
                    direccion_obj: {},
                    estacionamiento: ''
                },
                oferta:{
                }
            },
            codigos: ['+56', '+51','+54','+55', '+56','+57','+58','+1','+591','+593','+595','+598'],
            rules: {
                nameRules: [
                    v => !!v || 'Campo obligatorio'
                ],
                emailRules: [
						v => !!v || 'Campo obligatorio',
						v => {
							const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
							if(re.test(v)){
								return true
							}
							return 'Verifica que el email sea válido'
						}
					]
            },
            codigoDefault: '+56',
            phoneLength: 9,
        }
    },
    methods: {
        changePhoneLength() {
            if (this.codigoDefault === '+56' || this.codigoDefault === '+51' || this.codigoDefault === '+595') {
                this.phoneLength = 9
            } else if (this.codigoDefault === '+57' || this.codigoDefault === '+1') {
                this.phoneLength = 10
            } else if (this.codigoDefault === '+54') {
                this.phoneLength = 11
            } else {
                this.phoneLength = 12
            }
        },
        eventTracker(tipo) {
            gtag('event', tipo, {
            'event_category' : tipo,
            'event_label' : tipo
            })
        },
        validate(move) {
            
            if (this.datos.personales.nombre !== '' && this.datos.personales.apellido !== '' && this.datos.personales.email !== '' && this.datos.personales.telefono !== '') {
                this.datos.personales.nombrePila = this.datos.personales.nombre
                this.datos.personales.nombre = this.datos.personales.nombre + ' ' + this.datos.personales.apellido
                this.datos.personales.telefono = this.codigoDefault + '' + this.datos.personales.telefono
                var data = {
                    datos: this.datos,
                    valid: true,
                    move
                    
                }
                this.eventTracker('cotizacionFirst')
                EventBus.$emit('mudanzaFirstDemo', data);
                
            }
            
        },
        setAddress(data){
				// Seteamos la data de dirección como promesa para poder esperar que esto esté listo en retomarPedido abajo
      return new Promise((resolve, reject) => {
          const self = this
          const geocoder = new google.maps.Geocoder()
          const origen = new Promise((resolve, reject) => {
              geocoder.geocode({'address': data.direcciones.origen}, function(results, status) {
              if (status === 'OK') {
                  self.datos.direccion_origen.marker = results[0].geometry.location
              } else {
                  alert('Geocode was not successful for the following reason: ' + status);
              }
              resolve(true)
              })
          })
          const destino = new Promise((resolve, reject) => {
            geocoder.geocode({'address': data.direcciones.destino}, function(results, status) {
              if (status === 'OK') {
                self.datos.direccion_destino.marker = results[0].geometry.location
              } else {
                alert('Geocode was not successful for the following reason: ' + status);
              }
              resolve(true)
            })	
          })

          Promise.all([origen, destino]).then(values => { 
            resolve(true)
          });
        })  
      }
        
    },
    mounted() {
        EventBus.$on('retomarPedidoFirstDemo', data => {
            this.datos.personales = data.personales
            EventBus.$emit('avanzarRetomarDemo', {e1: 2})
        })
    }
}
</script>